module.exports = __webpack_public_path__ + "static/img/logo.8e245cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = 2997
// module chunks = 1